module.exports = __webpack_public_path__ + "fonts/NeuePlakTextBold_normal_normal.48ef07e.woff2";